import { h, Host } from "@stencil/core";
export class FormGroup {
    constructor() {
        this.label = "";
        this.labelInfo = "";
        this.required = false;
        this.error = false;
        this.errorMsg = "";
        this.labelClasses = "";
        this.name = "";
        this.manageAllCheckboxes = undefined;
        this.manageAllWrapperClass = "";
        this.manageAllChecked = false;
    }
    element;
    manageAllCheckbox;
    manageAllValue = "manage-all-checkboxes";
    onManageAllChange = (e) => {
        const checkboxes = Array.from(this.element.querySelectorAll("ux-checkbox"));
        checkboxes.forEach((checkbox) => {
            checkbox.setAttribute("checked", e.detail.checked);
        });
    };
    handleManageAllCheckboxStatus = (e) => {
        if (this.manageAllCheckboxes !== undefined) {
            const eTarget = e.target;
            if (eTarget === this.manageAllCheckbox) {
                return;
            }
            const checkboxes = Array.from(this.element.querySelectorAll(`ux-checkbox:not([value="${this.manageAllCheckboxes}"])`));
            let checkedCheckboxes = 0;
            // @ts-expect-error Check for typing
            checkboxes.forEach((checkbox) => {
                if (checkbox !== this.manageAllCheckbox && checkbox.checked) {
                    checkedCheckboxes++;
                }
            });
            if (checkedCheckboxes !== checkboxes.length - 1) {
                this.manageAllCheckbox.setAttribute("checked", "false");
            }
            else {
                this.manageAllCheckbox.setAttribute("checked", "true");
            }
        }
    };
    render() {
        const baseClass = "ux-form-group";
        const { label, labelInfo, required, error, errorMsg, labelClasses, manageAllCheckboxes } = this;
        return (h(Host, { key: 'c628c630dd36862ada356976500fbd40d3acdbe9', class: {
                [baseClass]: true,
                [`${baseClass}--error`]: this.error
            }, onUxCheckboxChange: this.handleManageAllCheckboxStatus }, h("fieldset", { key: '4d3a8377b7f211f426a54b0f52b2253b2c156bcf', class: `${baseClass}__fieldset` }, h("ux-input-label", { key: '258c8cc7a3335cfb1b03ed7299ad8bb4c53510c9', labelClasses: labelClasses, text: label, error: error, errorMsg: errorMsg, required: required, labelInfo: labelInfo }), h("div", { key: '47ed913b5c23fcd91fabc4bad161403e01a82505', class: `${baseClass}__wrapper` }, manageAllCheckboxes && (h("div", { key: 'f48b82feb16cfe5ce259f80228b441346b6837ef', class: this.manageAllWrapperClass }, h("ux-checkbox", { key: 'c2253e86e46441f6cdc2f65165cf57095324ff4e', onUxCheckboxChange: this.onManageAllChange, label: manageAllCheckboxes, value: this.manageAllValue,
            // @ts-expect-error Check for typing
            ref: (el) => (this.manageAllCheckbox = el), checked: this.manageAllChecked }))), h("slot", { key: '30d379e4970c440574a1aa434eb91d2d06ca60f6' })))));
    }
    static get is() { return "ux-form-group"; }
    static get originalStyleUrls() {
        return {
            "$": ["form-group.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-group.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "label text describing the form fields"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelInfo": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "additional info label for the the input field"
                },
                "attribute": "label-info",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the form group is required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the form group has an error state"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Error message that is rendered if component has an error"
                },
                "attribute": "error-msg",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelClasses": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "utility classes to be assigned to the label element"
                },
                "attribute": "label-classes",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "name assigned to the form group"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "manageAllCheckboxes": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, an additional checkbox will be displayed that manages\nall the checkbox present inside the form group"
                },
                "attribute": "manage-all-checkboxes",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "manageAllWrapperClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "string of classes that will be assigned to the manage all checkbox wrapper, if present"
                },
                "attribute": "manage-all-wrapper-class",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "manageAllChecked": {}
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=form-group.js.map
